<div class="row">
  <div class="col-md-12">
    <div class="alert alert-info">
      <div class="d-flex justify-content-between">
        <h6 class="alert-heading"><i class="fa-solid fa-wand-sparkles"></i>AI Summary</h6>
        <i class="fa me-0" [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'" (click)="showSummary()" type="button"></i>
      </div>
      <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="mt-2">
        @if(!loading) {
          <p>{{ summaryOfNotes || 'Not generated yet...' }}</p>

          <div class="d-flex justify-content-between">
            <button (click)="getSummary(true)" class="btn btn-sm btn-primary">
              <i class="fa fa-redo"></i>Try again
            </button>
            <div *ngIf="reviewsActive && summaryOfNotes" class="pb-2">
              <i role="button" class="fa-regular fa-thumbs-up icon-bg-circle"></i>
              <i role="button" class="fa-regular fa-thumbs-down fa-flip-horizontal icon-bg-circle"></i>
            </div>
          </div>
          <div>
          </div>
        }
        @else {
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
